import { HeroldMap } from "./modulesMap/HeroldMap";
import { $listings } from "./modules/variables";

$(function () {
  //IE11 Fix
  var originalMargin = $("#map").css("margin-top");
  function onFullscreenChange() {
    if ($("#map").css("margin-top") == "0px") {
      $("#map").css("margin-top", originalMargin);
    } else {
      $("#map").css("margin-top", "0px");
    }
  }
  window.document.addEventListener("MSFullscreenChange", onFullscreenChange);

  /**
   * NEW Map in der Ergebnisliste und Detailseite
   */
  var $body = $("body"),
    $resultMapGL = $("#mainMap"),
    $overlayMapGL = $("#overlayMap");

  if ($resultMapGL.length) {
    if (typeof featuresSponsorAdvertiser === "undefined") {
      var featuresSponsorAdvertiser = {};
      featuresSponsorAdvertiser.features = [];
    }
    if (typeof featuresForeignAdvertiser === "undefined") {
      var featuresForeignAdvertiser = {};
      featuresForeignAdvertiser.features = [];
    }

    var overlayMap;
    var resultMap = new HeroldMap()
      .setKey(mapboxGLKey)
      .setType("resultList")
      .setControls($resultMapGL.data())
      .setZoom(0)
      .setPoiconfig(poiconfig)
      .setFeatures(features)
      .setFeaturesAdditional(
        featuresSponsorAdvertiser,
        featuresForeignAdvertiser
      )
      .build();

    $("#showMapOverlay").on("click", function () {
      $(".mapboxgl-ctrl-overlay").click();
    });
    if ($("#searchresult").attr("showMap") == "true") {
      $(".mapboxgl-ctrl-overlay").click();
    }
    if ($("#detailBox").attr("showMap") == "true") {
      $(".mapboxgl-ctrl-overlay").click();
    }

    /**
     * Pin in Karte hervorheben wenn über das Listing gehovered wird
     */
    $listings.on("mouseenter mouseleave", function (e) {
      var marker;
      if ($(this).data("adv-sponsor")) {
        marker = "#companyPinStar" + $(this).data("uid");
      } else {
        marker = "#companyPin" + $(this).data("uid");
      }
      if (e.type === "mouseenter") {
        $(marker).addClass("toFront");
      } else {
        $(marker).removeClass("toFront");
      }
    });

    $("#overlayMapModal").on("shown.bs.modal", function () {
      if (!overlayMap) {
        overlayMap = new HeroldMap()
          .setKey(mapboxGLKey)
          .setType("overlay")
          .setControls($overlayMapGL.data())
          .setZoom(0)
          .setPoiconfig(poiconfig)
          .setFeatures(features)
          .setFeaturesAdditional(
            featuresSponsorAdvertiser,
            featuresForeignAdvertiser
          )
          .build();
      } else {
        overlayMap.centerMap(features.features[0].geometry.coordinates);
      }
    });
  }
});
